import React from "react";
import { useQuery } from 'react-query'
import { getResultsRSC } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import BmfScoreboard from "components/sports/bmf/views/BmfScoreboard";
import SportCode from "components/common/SportCode";
import 'styles/modules/BmfResults.scss';
import PreviousCompetitor from "components/sports/bmf/views/PreviousCompetitor";
import CurrentCompetitor from "components/sports/bmf/views/CurrentCompetitor";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
const BmfContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()

    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data?.results) { return <NotAvailable /> }

    return (
        <>
            <PageHeader data={data} />
            <div className='mirs-page-container'>
            <PreviousCompetitor data={data} />
            <CurrentCompetitor data={data} />
            {data?.results?.eventUnitCode.includes('FNL')
                ? <></>
                : <div className="fw-bold"><SportCode discipline={mirs_discipline} entity={'@QualRule'} code={'PT9^F'} /></div>
            }
            <div className='my-5'>
                <BmfScoreboard data={data} />
            </div>
            </div>
        </>
    )

}

export default BmfContext;